import { useMemo } from 'react';
import { floatUidString } from 'utils/uid';

export const useCarouselClasses = () => {
  return useMemo(() => {
    const rand = floatUidString();

    return {
      swiper: `mySwiper-${rand}`,
      nextClass: `next-button-cp-rsg-${rand} controlButton`,
      previousClass: `previous-button-cp-rsg-${rand} controlButton`,
      nextElement: `.next-button-cp-rsg-${rand}`,
      previousElement: `.previous-button-cp-rsg-${rand}`,
    };
  }, []);
};
